import React from "react";
import Modal from "react-modal";
import { Button } from "@material-ui/core";

function GuideLinesModal({ openGuideLines, setOpenGuideLines }) {
	return (
		<div>
			<Modal
				isOpen={openGuideLines}
				onRequestClose={() => setOpenGuideLines(false)}
				style={{
					overlay: {
						width: 700,
						height: 700,
						backgroundColor: "transparent",
						boxShadow:
							"box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
						zIndex: "1100",
						top: "50%",
						left: "50%",
						marginTop: "-300px",
						marginLeft: "-350px",
					},
				}}
			>
				<div>
					<h3
						style={{
							paddingTop: "40px",
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						Please Answer the question in the following format:
						<br style={{ margin: "0px" }} />
						&nbsp;
					</h3>
					<h4
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						<i style={{ margin: "0px" }}>
							Broad steps of what to do in bullet points:
						</i>
						<br style={{ margin: "0px" }} />
						&nbsp;
					</h4>
					<ol
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						<li style={{ margin: "0px" }}>
							Start here, you'll want to make sure that [X] is set up and you
							have the [Y] information.
						</li>
						<li style={{ margin: "0px" }}>
							Once the previous step is finished, make sure that you have [Z]
							prepared because that will build upon [X].
						</li>
						<li style={{ margin: "0px" }}>
							Finally you will need to finish it by looking at the best way to
							combine [X], [Y], and [Z].
						</li>
					</ol>
					<p
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						&nbsp;
					</p>
					<h4
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						Include any technology stack or equipment that the person might need
						to be aware of:
						<br style={{ margin: "0px" }} />
						&nbsp;
					</h4>
					<ul
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						<li style={{ margin: "0px" }}>
							Languages and frameworks: React &amp; Javascript
						</li>
						<li style={{ margin: "0px" }}>
							Software: Atom or Visual Studio Code
						</li>
					</ul>
					<p
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						&nbsp;
					</p>
					<h4
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						Finally, please include any supplement external material to help
						them start:
					</h4>
					<p
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						&nbsp;
					</p>
					<ol
						style={{
							margin: "0px",
							color: "rgb(0, 0, 0)",
							fontFamily:
								'-apple-system, system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
							fontSize: "medium",
							fontStyle: "normal",
							fontVariantLigatures: "normal",
							fontVariantCaps: "normal",
							fontWeight: 400,
							letterSpacing: "normal",
							orphans: 2,
							textAlign: "start",
							textIndent: "0px",
							textTransform: "none",
							whiteSpace: "normal",
							widows: 2,
							wordSpacing: "0px",
							WebkitTextStrokeWidth: "0px",
							backgroundColor: "rgb(255, 255, 255)",
							textDecorationThickness: "initial",
							textDecorationStyle: "initial",
							textDecorationColor: "initial",
						}}
					>
						<li style={{ margin: "0px" }}>Youtube tutorial link</li>
						<li style={{ margin: "0px" }}>Medium Article</li>
					</ol>
					<div className="GuideLinesModal__Button">
						<Button onClick={() => setOpenGuideLines(false)}>Cancel</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
}

export default GuideLinesModal;
